import { styled, Text } from '@auth0/quantum-product';
export var WidgetTitle = styled(Text)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(2),
    });
});
